export default __webpack_public_path__ + "static/media/beep.519d870c.mp3";